import React from 'react';
import { ProductResponse } from 'types';
import { DetailPage } from 'modules/product-detail/desktop';
import { getServerSidePropsDetail } from 'modules/product-detail/shared';
import { ProductDetailProvider } from 'contexts';
import { IBannerInlinePlaceholderProps } from '@tekface/smart-activation';

export interface ProductDetailsProps {
  serverProduct: ProductResponse;
  inlineBanners?: IBannerInlinePlaceholderProps<{}>['banners'];
}

const ProductDetailsPage: React.FunctionComponent<ProductDetailsProps> = ({
  serverProduct,
  inlineBanners,
}: ProductDetailsProps) => {
  return (
    <ProductDetailProvider
      serverProduct={serverProduct}
      inlineBanners={inlineBanners}
    >
      <DetailPage />
    </ProductDetailProvider>
  );
};

export const getServerSideProps = getServerSidePropsDetail;

export default ProductDetailsPage;
